var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8536 12.3536L12.5607 16.6465C12.3654 16.8418 12.0488 16.8418 11.8536 16.6465L11.1502 15.9431C10.9551 15.7481 10.9549 15.4319 11.1497 15.2365L14.3771 12.0001L11.1497 8.76363C10.9549 8.56829 10.9551 8.25208 11.1502 8.05701L11.8536 7.35363C12.0488 7.15837 12.3654 7.15837 12.5607 7.35363L16.8536 11.6465C17.0488 11.8418 17.0488 12.1584 16.8536 12.3536Z",
    fill: "#21272A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0606 12.3536L7.76769 16.6465C7.57243 16.8418 7.25585 16.8418 7.06058 16.6465L6.3572 15.9431C6.16213 15.7481 6.16191 15.4319 6.35671 15.2365L9.58414 12.0001L6.35671 8.76363C6.16191 8.56829 6.16213 8.25208 6.3572 8.05701L7.06058 7.35363C7.25585 7.15837 7.57243 7.15837 7.76769 7.35363L12.0606 11.6465C12.2558 11.8418 12.2558 12.1584 12.0606 12.3536Z",
    fill: "#21272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCaretRight);
export default __webpack_public_path__ + "static/media/double-caret-right.bec968b8.svg";
export { ForwardRef as ReactComponent };